import { rem } from 'polished';

import { forwardRef } from 'react';
import { ProminentButtonBackground as Background } from './Background';
import { ProminentButtonBorder as Border } from './Border';
import { ProminentButtonContainer as Container } from './Container';
import { ProminentButtonEffect as Effect } from './Effect';
import { ProminentButtonGlow as Glow } from './Glow';
import { ProminentButtonLabel as Label } from './Label';
import { ProminentButtonProps as Props } from './ProminentButton.props';

export const ProminentButton = forwardRef(
  (
    {
      effect,
      children,
      display,
      position,
      pl,
      pr,
      px,
      paddingX,
      paddingLeft,
      paddingRight,
      ...props
    }: Props,
    ref,
  ) => (
    <Container
      {...props}
      ref={ref}
      display={display || 'block'}
      position={position && position !== 'static' ? position : 'relative'}
      overflow="visible"
      border="none"
    >
      <Glow position="absolute" top={0} left={0} />

      <Border position="absolute" inset={0} />

      <Effect
        position="absolute"
        inset={0}
        opacity={effect === true ? 1 : 0}
        transition="opacity 300ms"
        sx={{
          'button:hover > &, a:hover > &': {
            opacity: effect === true ? 0.4 : 1,
          },
        }}
      />

      <Background position="absolute" inset={rem(3)} />

      <Label
        position="relative"
        pr={pr}
        paddingRight={paddingRight}
        pl={pl}
        paddingLeft={paddingLeft}
        px={px}
        paddingX={paddingX}
      >
        {children}
      </Label>
    </Container>
  ),
);
